import { LagerauswertungAlleCompareProducts } from "@/components/lagerauswertung/la-compare-products";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/lagerauswertung/compare-products/$date/$date2")({
  component: RouteComponent,
});

function RouteComponent() {
  const { date, date2 } = Route.useParams();
  const navigate = useNavigate();
  const changeDate = (date: string, date2: string) => {
    navigate({
      to: "/lagerauswertung/compare-products/$date/$date2",
      params: { date, date2 },
    });
  };
  return <LagerauswertungAlleCompareProducts date={date} date2={date2} changeDate={changeDate} />;
}
